import gsap from 'gsap/all'
import { debounce } from './_helpers'

export default function initSwitcher(page, eventListenersRemover) {
  page.querySelectorAll('[data-switcher]').forEach(switcher => {
    const switcherSlider = switcher.querySelector('[data-switcher-slider]')
    const switcherLabels = switcher.querySelectorAll('[data-switcher-label]')
    const updateStyles = target => {
      gsap
        .timeline()
        .to(switcherSlider, {
          duration: 0.3,
          x: target.offsetLeft,
        })
        .to(
          switcherSlider,
          {
            duration: 0.3,
            width: target.clientWidth - 8,
          },
          '<='
        )
    }

    switcherLabels.forEach((label, i) => {
      label.addEventListener('click', e => {
        updateStyles(e.target)
        switcherSlider.dataset.position = i.toString()
      })

      if (switcher.querySelector(`[data-first-active]`)) {
        label.click()
      }
    })

    const debouncedUpdateStyles = debounce(() => {
      updateStyles(switcherLabels[+switcherSlider.dataset.position])
    }, 100)

    window.addEventListener('resize', debouncedUpdateStyles)

    eventListenersRemover.push({
      el: window,
      event: 'resize',
      func: debouncedUpdateStyles,
    })
  })
}
